import { z } from "zod";
// One mailbox, never a display-name/address list or a header value supplied by the caller.
export const InvitationEmailRequestSchema = z.object({
    email: z.string().trim().max(254).email().regex(/^[\x21-\x7e]+$/).transform((value) => value.toLowerCase()),
    idempotencyKey: z.string().uuid(),
}).strict();
//# sourceMappingURL=invitation-email.js.map